import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class HeatmapCapturesService extends ApiService {
  constructor(private http: Http) {
    super('api/heatmap-captures/', http);
  }

  public get_heatmap_captures(data): Observable<Object> {
    const url = this.apiUrl + `api/captures-cache/?` + data;
    return this.http.get(url, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public get_heatmap_discards(data): Observable<Object> {
    const url = this.apiUrl + `api/discards-cache/?` + data;
    return this.http.get(url, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/heatmap-captures.service.ts